import { handleActions } from 'redux-actions';
import {GET_DATA_IMPORTS,GET_DATA_IMPORT_CODE,GET_CLEAN_DATA_IMPORT_CODE } from '../constants/get';

export const DataImports = handleActions ({
    [GET_DATA_IMPORTS]: (state, action) => action.payload,
    [GET_DATA_IMPORT_CODE]:(state,action)=> {
        if(action.payload.length>0){
            const table = action.payload;
            const res = state.reduce((acc, imp) =>{
                if(imp.code_import === table[0].code_import){
                    imp.Tables = table;
                }
                return [...acc, imp]; 
            },[]);
            return res;
        }
        else
            return action.payload;
    },
    [GET_CLEAN_DATA_IMPORT_CODE]:(state,action)=> {
            const code = action.payload;
            const res = state.reduce((acc, imp) =>{
                if(imp.code_import === code){
                    delete imp.Tables;
                }
                return [...acc, imp]; 
            },[]);
            return res;
    },
},[]);
